import { useQuery } from '@tanstack/react-query';
import { listMemberships } from './api';

export function useMemberships(userId: string) {
  return useQuery({
    queryKey: ['memberships', userId],
    queryFn: () => listMemberships(userId),
    staleTime: 30_000
  });
}
